import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { VendorFormWrapperComponent } from '../vendor-form/vendor-form-wrapper.component';

@Component({
  selector: 'app-vendor-edit',
  standalone: true,
  imports: [CommonModule, VendorFormWrapperComponent],
  templateUrl: './vendor-edit.component.html',
  styleUrl: './vendor-edit.component.css',
})
export class VendorEditComponent
  implements OnInit, OnDestroy, CanComponentDeactivate
{
  private route = inject(ActivatedRoute);
  private destroy$ = new Subject<void>();
  vendorId = signal<string | null>(null);

  @ViewChild('formWrapper') private readonly formWrapper?: VendorFormWrapperComponent;

  ngOnInit(): void {
    // Subscribe to route parameter changes to handle navigation
    // between different vendor edit pages
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params.get('id');
      this.vendorId.set(id);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}

